export const MY_PRODUCTS_KEY = 'store-products' as const;
export const PRODUCT_LOGOS_KEY = 'store-logos' as const;
export const RESTART_TOUR_KEY = 'restart-tour-button' as const;
export const CHAT_BUTTON_KEY = 'hubspot-chat-button' as const;
